import store from '../../../store';

/**
 *
 * [key]: {
 *   label: string,
 *   hint: string,
 *   dependOn: Function // (form) => !!form.item,
 *   component: [
 *      'TextField',
 *      'TextareaField',
 *      'InfoField',
 *      'SelectField',
 *      'CatalogField',
 *      'DateField',
 *      'FileUploadField' // drag and drop file input
 *   ],
 *   slug: string // только для component = CatalogField
 *   validation: string
 *   type: 'Number', 'Date', 'Array', 'String', 'Boolean',
 *   caption: {
 *    title: 'Заголовок секции',
 *    hintAbove: 'Подсказка над полем',
 *    hintBelow: 'Подсказка под полем',
 *    hintAboveVariant: 'info' | 'warning' | 'neutral', // цвет подсказки, по умолчанию info
 *    hintBelowVariant: 'info' | 'warning' | 'neutral',
 *  },
 * }
 */
const TRUE_VALUE = true;
const FALSE_VALUE = false;
// const DOCS_VALIDATION = 'ext:pdf,jpg,png,jpeg|size:10|sumSize:100';

export default {
  computed: {
    TRUE_FALSE_ITEMS() {
      return [
        { value: TRUE_VALUE, text: this.$t('constant.true') },
        { value: FALSE_VALUE, text: this.$t('constant.false') },
      ];
    },
    CAPTION_TECHNICS() {
      return {
        title: this.$t('field.caption_technics'),
        hintAbove: this.$t('field.caption_technics__hintAbove'),
      };
    },
    CAPTION_EMERGENCY() {
      return {
        title: this.$t('field.caption_emergency'),
        hintAbove: this.$t('field.caption_emergency__hintAbove'),
      };
    },
    GENDER_ITEMS() {
      return [
        { value: 'M', text: this.$t('constant.gender.male') },
        { value: 'F', text: this.$t('constant.gender.female') },
      ];
    },
    fieldsParams() {
      return {
        first_name: {
          label: this.$t('field.first_name'),
          component: 'TextField',
          validation: 'required',
          type: 'String',
        },
        last_name: {
          label: this.$t('field.last_name'),
          component: 'TextField',
          validation: 'required',
          type: 'String',
        },
        patronymic_name: {
          label: this.$t('field.patronymic_name'),
          component: 'TextField',
          type: 'String',
        },
        birthdate: {
          label: this.$t('field.birthdate'),
          component: 'DateField',
          validation: 'required|notLaterToday',
          type: 'Date',
        },
        gender: {
          label: this.$t('field.gender'),
          component: 'SelectField',
          items: [...this.GENDER_ITEMS],
          validation: 'required',
          type: 'String',
        },
        country: {
          label: this.$t('field.country'),
          component: 'TextField',
          validation: 'required',
          type: 'String',
        },
        city: {
          label: this.$t('field.city'),
          component: 'TextField',
          validation: 'required',
          type: 'String',
        },
        address: {
          label: this.$t('field.address'),
          hint: this.$t('field.address__hint'),
          component: 'TextField',
          validation: 'required',
          type: 'String',
        },
        address_postcode: {
          label: this.$t('field.address_postcode'),
          component: 'TextField',
          validation: 'required',
          type: 'String',
        },
        equipment_recipient: {
          label: this.$t('field.equipment_recipient'),
          component: 'TextField',
          validation: 'required',
          type: 'String',
        },
        phone: {
          label: this.$t('field.phone'),
          hint: this.$t('field.phone__hint'),
          component: 'TextField',
          validation: 'required|numeric',
          type: 'String',
        },
        contact_other: {
          label: this.$t('field.contact_other'),
          hint: this.$t('field.contact_other__hint'),
          component: 'TextField',
          type: 'String',
        },
        telegram: {
          label: this.$t('field.telegram'),
          hint: this.$t('field.telegram__hint'),
          component: 'TextField',
          validation: 'required',
          type: 'String',
        },
        emergency_primary: {
          label: this.$t('field.emergency_primary'),
          hint: this.$t('field.emergency_primary__hint'),
          component: 'TextField',
          validation: 'required',
          type: 'String',
          caption: this.CAPTION_EMERGENCY,
        },
        emergency_current_location: {
          label: this.$t('field.emergency_current_location'),
          hint: this.$t('field.emergency_current_location__hint'),
          component: 'TextField',
          type: 'String',
          caption: {
            hintBelow: this.$t('field.caption_emergency__hintBelow'),
            hintBelowVariant: 'warning',
          },
        },
        type_work: {
          label: this.$t('field.type_work'),
          hint: this.$t('field.type_work__hint'),
          component: 'CatalogField',
          slug: 'work_formats',
          type: 'Number',
        },
        office: {
          label: this.$t('field.office'),
          component: 'CatalogField',
          slug: 'offices',
          dependOn: {
            param: 'type_work',
            comparator: value => {
              return store.getters['settings/office'].indexOf(value) !== -1;
            },
          },
          type: 'Number',
        },
        need_hardware: {
          label: this.$t('field.need_hardware'),
          hint: this.$t('field.need_hardware__hint'),
          component: 'SelectField',
          items: [...this.TRUE_FALSE_ITEMS],
          type: 'Boolean',
          caption: this.CAPTION_TECHNICS,
        },
        existing_hardware: {
          label: this.$t('field.existing_hardware'),
          component: 'TextareaField',
          dependOn: {
            param: 'need_hardware',
            value: TRUE_VALUE,
          },
          validation: 'required',
          type: 'String',
        },
        needed_hardware: {
          label: this.$t('field.needed_hardware'),
          hint: this.$t('field.needed_hardware__hint'),
          component: 'TextareaField',
          validation: 'required',
          type: 'String',
          isMarkdown: true,
        },
        has_hardware: {
          label: this.$t('field.has_hardware'),
          component: 'SelectField',
          items: [...this.TRUE_FALSE_ITEMS],
          dependOn: {
            param: 'need_hardware',
            value: TRUE_VALUE,
          },
          validation: 'required',
          type: 'Boolean',
        },
        hardware_spec: {
          label: this.$t('field.hardware_spec'),
          hint: this.$t('field.hardware_spec__hint'),
          component: 'TextareaField',
          dependOn: {
            param: 'need_hardware',
            value: FALSE_VALUE,
          },
          validation: 'required',
          type: 'String',
        },
        passport_ru: {
          label: this.$t('field.passport_ru'),
          hint: this.$t('field.passport_ru__hint'),
          multiple: true,
          component: 'FileUploadField',
          type: 'Array',
        },
        snils: {
          label: this.$t('field.snils'),
          multiple: true,
          component: 'FileUploadField',
          type: 'Array',
        },
        tax_identification_number: {
          label: this.$t('field.tax_identification_number'),
          multiple: true,
          component: 'FileUploadField',
          type: 'Array',
        },
        tax_identification_number_ua: {
          label: this.$t('field.tax_identification_number_ua'),
          hint: this.$t('field.tax_identification_number_ua__hint'),
          multiple: true,
          component: 'FileUploadField',
          type: 'Array',
        },
        employment_history: {
          label: this.$t('field.employment_history'),
          hint: this.$t('field.employment_history__hint'),
          multiple: true,
          component: 'FileUploadField',
          type: 'Array',
        },
        employment_history_ua: {
          label: this.$t('field.employment_history_ua'),
          hint: this.$t('field.employment_history_ua__hint'),
          multiple: true,
          component: 'FileUploadField',
          type: 'Array',
        },
        education_document: {
          label: this.$t('field.education_document'),
          multiple: true,
          component: 'FileUploadField',
          type: 'Array',
        },
        education_document_by: {
          label: this.$t('field.education_document_by'),
          multiple: true,
          component: 'FileUploadField',
          type: 'Array',
        },
        military_registration_document: {
          label: this.$t('field.military_registration_document'),
          hint: this.$t('field.military_registration_document__hint'),
          multiple: true,
          component: 'FileUploadField',
          type: 'Array',
        },
        disability_certificate: {
          label: this.$t('field.disability_certificate'),
          hint: this.$t('field.disability_certificate__hint'),
          multiple: true,
          component: 'FileUploadField',
          type: 'Array',
        },
        child_tax_identification_number: {
          label: this.$t('field.child_tax_identification_number'),
          multiple: true,
          component: 'FileUploadField',
          type: 'Array',
        },
        child_birth_certificate: {
          label: this.$t('field.child_birth_certificate'),
          hint: this.$t('field.child_birth_certificate__hint'),
          multiple: true,
          component: 'FileUploadField',
          type: 'Array',
        },
        child_birth_certificate_ua: {
          label: this.$t('field.child_birth_certificate_ua'),
          hint: this.$t('field.child_birth_certificate_ua__hint'),
          multiple: true,
          component: 'FileUploadField',
          type: 'Array',
        },
        passport_by: {
          label: this.$t('field.passport_by'),
          hint: this.$t('field.passport_by__hint'),
          multiple: true,
          component: 'FileUploadField',
          type: 'Array',
        },
        passport_ua: {
          label: this.$t('field.passport_ua'),
          hint: this.$t('field.passport_ua__hint'),
          multiple: true,
          component: 'FileUploadField',
          type: 'Array',
        },
        '182-n_document': {
          label: this.$t('field.182-n_document'),
          hint: this.$t('field.182-n_document__hint'),
          multiple: true,
          component: 'FileUploadField',
          type: 'Array',
        },
        '2ndfl_document': {
          label: this.$t('field.2ndfl_document'),
          hint: this.$t('field.2ndfl_document__hint'),
          multiple: true,
          component: 'FileUploadField',
          type: 'Array',
        },
        bank_details: {
          label: this.$t('field.bank_details'),
          hint: this.$t('field.bank_details__hint'),
          multiple: true,
          component: 'FileUploadField',
          type: 'Array',
        },
        std_documents: {
          label: this.$t('field.std_documents'),
          hint: this.$t('field.std_documents__hint'),
          multiple: true,
          component: 'FileUploadField',
          type: 'Array',
        },
        social_insurance_certificate_ua: {
          label: this.$t('field.social_insurance_certificate_ua'),
          multiple: true,
          component: 'FileUploadField',
          type: 'Array',
        },
        cv_document: {
          label: this.$t('field.cv_document'),
          multiple: true,
          component: 'FileUploadField',
          type: 'Array',
        },
        benefit_statement: {
          label: this.$t('field.benefit_statement'),
          hint: this.$t('field.benefit_statement__hint'),
          multiple: true,
          component: 'FileUploadField',
          type: 'Array',
        },
        medical_examination_certificate: {
          label: this.$t('field.medical_examination_certificate'),
          hint: this.$t('field.medical_examination_certificate__hint'),
          multiple: true,
          component: 'FileUploadField',
          type: 'Array',
        },
        medical_examination_certificate_ua: {
          label: this.$t('field.medical_examination_certificate_ua'),
          hint: this.$t('field.medical_examination_certificate_ua__hint'),
          multiple: true,
          component: 'FileUploadField',
          type: 'Array',
        },
        social_insurance_certificate_by: {
          label: this.$t('field.social_insurance_certificate_by'),
          hint: this.$t('field.social_insurance_certificate_by__hint'),
          multiple: true,
          component: 'FileUploadField',
          type: 'Array',
        },
        bank_details_by: {
          label: this.$t('field.bank_details_by'),
          multiple: true,
          component: 'FileUploadField',
          type: 'Array',
        },
        rehabilitation_plan: {
          label: this.$t('field.rehabilitation_plan'),
          hint: this.$t('field.rehabilitation_plan__hint'),
          multiple: true,
          component: 'FileUploadField',
          type: 'Array',
        },
        photo3x4: {
          label: this.$t('field.photo3x4'),
          multiple: false,
          component: 'FileUploadField',
          type: 'Array',
        },
        full_name_en: {
          label: this.$t('field.full_name_en'),
          hint: this.$t('field.full_name_en__hint'),
          component: 'TextField',
          validation: 'required',
          type: 'String',
        },
        citizenship: {
          label: this.$t('field.citizenship'),
          component: 'TextField',
          validation: 'required',
          type: 'String',
        },
        passport_number: {
          label: this.$t('field.passport_number'),
          hint: this.$t('field.passport_number__hint'),
          component: 'TextField',
          validation: 'required',
          type: 'String',
        },
        residence_address: {
          label: this.$t('field.residence_address'),
          hint: this.$t('field.residence_address__hint'),
          component: 'TextField',
          validation: 'required',
          type: 'String',
        },
        email_plr: {
          label: this.$t('field.email_plr'),
          component: 'TextField',
          validation: 'required|email',
          type: 'String',
        },
        beneficiary_bank_name: {
          label: this.$t('field.beneficiary_bank_name'),
          component: 'TextField',
          validation: 'required',
          type: 'String',
          caption: {
            title: this.$t('field.bank_details_en'),
            hintAbove: this.$t('field.bank_details_en__hintAbove'),
          },
        },
        beneficiary_bank_swift: {
          label: this.$t('field.beneficiary_bank_swift'),
          component: 'TextField',
          validation: 'required',
          type: 'String',
        },
        beneficiary_bank_iban: {
          label: this.$t('field.beneficiary_bank_iban'),
          component: 'TextField',
          validation: 'required',
          type: 'String',
        },
        intermediary_bank_name: {
          label: this.$t('field.intermediary_bank_name'),
          component: 'TextField',
          validation: 'required',
          type: 'String',
        },
        intermediary_bank_swift: {
          label: this.$t('field.intermediary_bank_swift'),
          component: 'TextField',
          validation: 'required',
          type: 'String',
        },
        intermediary_bank_iban: {
          label: this.$t('field.intermediary_bank_iban'),
          component: 'TextField',
          validation: 'required',
          type: 'String',
        },
      };
    },
  },
};
